import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoginDataModel } from "../../models/Reducer.model";
import { current } from "@reduxjs/toolkit"; 

const initialState: LoginDataModel = {
    userName: "",
    password: "",
    language: "",
    loggedUserDetails: [],
    countriesDropDown: [],
    selectedCounty: {},
    initialCountry: {},
    roleId: 12,
    tokenDetails: {},
    sideMenuData: [],
    languageDetails: [],

  };

const LoginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        getUserAccessDetails: (state) => {
            state.sideMenuData = [];
        },
        onUserAccessMenuSuccess: (state, action: PayloadAction<any>) => {
            state.sideMenuData = action.payload.value;
        },
        getUserCountryDetails: (state) => {
            state.countriesDropDown = [];
        },
        getLanguageDetails: (state) => {
            state.languageDetails = [];
        },
        setLanguage: (state, action: PayloadAction<any>) => {
            state.language = action.payload;
        },
        onLanguageDetailsSuccess: (state, action: PayloadAction<any>) => {
            console.log("onLanguageDetailsSuccess", action.payload);
            state.languageDetails = action.payload;
        },
        getTokenDetails: (state, action: PayloadAction<{code: string|null, codeVerifier: string}>) => {
            console.log("getTokenDetails called", action.payload);
            state.tokenDetails = {};
        },
        setTokenDetails: (state, action: PayloadAction<any>) => {
            const tokenDetails = {
                ...action.payload,
                userName: action.payload.firstName+" "+action.payload.lastName
              };
            state.tokenDetails = tokenDetails;
        },
        onCountrySelect: (state, action: PayloadAction<any>) => {
            state.selectedCounty = action.payload || {};
           localStorage.setItem("countryId", action.payload.countryId);
           sessionStorage.setItem("countryId", action.payload.countryId);
        },
        onCountryUserListSuccess: (state, action: PayloadAction<any>) => {
            console.log("onCountryUserListSuccess", action.payload);
            state.countriesDropDown = action.payload.getUserCountryLists;
            if (sessionStorage.getItem("countryId") && sessionStorage.getItem("countryId") != "null" && sessionStorage.getItem("countryId") != "undefined") {
                let currentSelectedCountryId = sessionStorage.getItem("countryId") || "";
                let countryObj = state.countriesDropDown?.find((country: any) => country.countryId.toString() === currentSelectedCountryId.toString());
                state.selectedCounty = countryObj;
              } else {
                state.selectedCounty = action.payload.getUserCountryLists?.[0] || {};
              }
            
           localStorage.setItem("adminType", JSON.stringify(action.payload.adminResponse?.[0]));
        },
    }
});

export const {
    getUserAccessDetails,
    onUserAccessMenuSuccess,
    getUserCountryDetails,
    onCountryUserListSuccess,
    getLanguageDetails,
    onLanguageDetailsSuccess,
    setLanguage,
    setTokenDetails,
    getTokenDetails,
    onCountrySelect
} = LoginSlice.actions;

export default LoginSlice.reducer;